// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__RHnRs","header":"Contact_header__c+0GH","main":"Contact_main__FU5FZ"};